import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators, FormGroupDirective, NgModel } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MerchantAccountType, UniversityPerson, MerchantProfileService, MerchantProfileSelectItem, MerchantAccount, MerchantAccountNameValidator, GeneralInformation, MerchantAccountService, ConfirmationComponent, MerchantProfile } from '../../../shared';

@Component({
    selector: 'app-general-information',
    templateUrl: './general-information.component.html'
})
export class GeneralInformationComponent implements OnInit {

    @Input() formGroupName: string;
    @Input() showErrors: boolean;
    @Output() onMerchantProfileChange: EventEmitter<UniversityPerson> = new EventEmitter<UniversityPerson>(true);

    generalInformation: GeneralInformation;
    generalInformationFormGroup: FormGroup;
    get merchantProfileId(): AbstractControl {
        return this.generalInformationFormGroup.get('merchantProfileId');
    }
    get preferredMerchantName(): AbstractControl {
        return this.generalInformationFormGroup.get('preferredMerchantName');
    }
    get customerServicePhoneNumber(): AbstractControl {
        return this.generalInformationFormGroup.get('customerServicePhoneNumber');
    }
    get productServiceSold(): AbstractControl {
        return this.generalInformationFormGroup.get('productServiceSold');
    }
    get acceptHSACreditCards(): AbstractControl {
        return this.generalInformationFormGroup.get('acceptHSACreditCards');
    }
    merchantProfiles: MerchantProfileSelectItem[];
    isCashnet: boolean;
    merchantId: string;

    constructor(
        private readonly rootFormGroup: FormGroupDirective,
        private readonly fb: FormBuilder,
        private readonly route: ActivatedRoute,
        private readonly modalService: NgbModal,
        private readonly merchantAccountService: MerchantAccountService,
        private readonly merchantProfileService: MerchantProfileService
    ) {
        
    }

    ngOnInit() {
        this.route.data.subscribe(({ merchantAccount }: { merchantAccount: MerchantAccount }) => {
            this.isCashnet = merchantAccount.merchantAccountType === MerchantAccountType.Cashnet;
            this.merchantId = merchantAccount.merchantId;
            this.merchantProfileService.getAllMerchantProfilesForSelection().subscribe((merchantProfiles) => {
                this.merchantProfiles = merchantProfiles;
            });
            this.generalInformation = merchantAccount.generalInformation;
            this.generalInformationFormGroup = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
            this.generalInformationFormGroup.addControl("merchantProfileId", this.fb.control(this.generalInformation.merchantProfileId, [Validators.required]));
            this.generalInformationFormGroup.addControl("preferredMerchantName", this.fb.control(this.generalInformation.preferredMerchantName, [Validators.required], [MerchantAccountNameValidator.validate(this.merchantAccountService, merchantAccount.id)]));
            var customerServicePhoneNumberValidators = this.isCashnet ? [] : [Validators.required, Validators.pattern("\\(\\d{3}\\)\\s\\d{3}-\\d{4}")];
            this.generalInformationFormGroup.addControl("customerServicePhoneNumber", this.fb.control(this.generalInformation.customerServicePhoneNumber, customerServicePhoneNumberValidators));
            this.generalInformationFormGroup.addControl("productServiceSold", this.fb.control(this.generalInformation.productServiceSold, [Validators.required]));
            this.generalInformationFormGroup.addControl("acceptHSACreditCards", this.fb.control(this.generalInformation.acceptHSACreditCards, [Validators.required]));
            this.merchantProfileId.valueChanges.subscribe((value) => {
                this.merchantProfileId.markAsTouched();
                var modal = this.modalService.open(ConfirmationComponent, { size: 'lg', backdrop: 'static' });
                modal.componentInstance.text = "Do you want to default the Primary Contact from the Merchant Profile?";
                modal.result.then((confirm) => {
                        if (confirm) {
                            this.merchantProfileService.getMerchantProfile(value).subscribe((merchantProfile: MerchantProfile) => {
                                this.onMerchantProfileChange.emit(merchantProfile.defaultContact);
                            });
                        }
                    },
                    () => {});
            });
        });
    }
}